// Copyright (c) 2017 Deere & Company

import RegistrationModals from '../state/registration-modals';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateRegistrationModals = (state, action) =>
    RegistrationModals.update(state, {
        [action.property]: {
            $set: action.isVisible
        }
    });

const updatePrintRegistrationModal = (state, action) =>
    RegistrationModals.update(state, {
        printRegistrationFormModal: {
            isVisible: {
                $set: action.isVisible
            },
            registrationId: {
                $set: action.registrationId
            },
            route: {
                $set: action.route
            }
        }
    });

const updateStatusChangeModalVisibility = (state, action) =>
    RegistrationModals.update(state, {
        registrationStatusChangeModal: {
            isVisible: {
                $set: action.isVisible
            }
        }
    });

export default (state = getDefaultState().registrationModals, action) => {

    const actionTypes = {
        [actions.UPDATE_PRODUCT_REGISTRATION_MODALS]: updateRegistrationModals,
        [actions.UPDATE_PRODUCT_REGISTRATION_PRINT_REGISTRATION_MODAL]: updatePrintRegistrationModal,
        [actions.UPDATE_PRODUCT_REGISTRATION_STATUS_CHANGE_MODAL]: updateStatusChangeModalVisibility
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/product-registration/reducers/registration-modals.js